import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FIRST_STEPS_VIDEO } from 'config/Vars'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import type { FirstStepVideo } from 'modules/onboarding/lib/firstSteps/types'

import FirstStepsVideo from '../Video'
import styles from './index.module.css'

interface Props {
  video: FirstStepVideo
}

const FirstStepsModal = ({ video }: Props) => {
  const [hide, setHide] = useLocalStorage(
    LOCAL_STORAGE_KEYS_FIRST_STEPS_VIDEO[video.section],
    false
  )

  const [showVideo, setShowVideo] = React.useState(false)

  const handlePlayVIdeo = () => {
    setShowVideo(true)
    track(trackingEvents.onboarding.watchFirstStepsVideo, {
      section: video?.section,
      source: 'section-popup',
    })
  }

  if (hide) return null

  if (showVideo) {
    return <FirstStepsVideo videoId={video.video_id} onClose={() => setHide(true)} />
  }

  return (
    <Box className={styles.firstStepModal}>
      <Box className={styles.firstStepModalHeader}>
        <Box className={styles.videoOverlay} onClick={handlePlayVIdeo}>
          <Box flexDirection="row" justifyContent="center" alignItems="center" height="full">
            <Box gap="s16" alignItems="center">
              <button className={styles.videoOverlayButton}>
                <Icon.Medium icon="play" color="grey1000" />
              </button>
            </Box>
          </Box>
        </Box>
        <img src={video.thumb} alt="Image" />
      </Box>
      <Box gap="s16" className={styles.firstStepModalInner}>
        <Box gap="s8">
          <Text color="grey1000" size="400" weight="semibold">
            {video.title}
          </Text>
          <Text size="200" color="grey1000">
            {video.subtitle}
          </Text>
        </Box>
        <Box gap="s8" flexDirection="row" justifyContent="flexEnd" alignItems="center">
          <Button type="secondary" onClick={() => setHide(true)}>
            {i18n.t('onboarding.first_steps.modal.action.cancel')}
          </Button>
          <Button onClick={handlePlayVIdeo}>
            {i18n.t('onboarding.first_steps.modal.action.watch_video')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
export default FirstStepsModal
